import Helpers from "./helpers";
import Storage from "./storage.service";
import Settings from "./settings";
import ReactDOM from "react-dom";
import {userHasDevicePlan} from "./vip.bundle.service"; 
import min60Pin from "../assets/img/pin.png";
import ETA_MAP_PIN from "../assets/img/pin.png";
import generalMapPin from "../assets/img/general_map_pin.png"
import Translations from "./translation";

var Maps = {
  mapIsLoaded: false,
  timer: null,
  instances: {},
  config: {},
  lat_shift: 0,
  markers: [],
  user_lat: 0,
  user_lng: 0,
  using_current_location: true,
  fetchingCurrentPosition: true,
  watcherOff: false,
  session_token: null,
};

Maps.long_press_ms = 500;
Maps.click_press_ms = 300;

// Maps.loadJS = (src) => {
  
//   const existingScript = document.getElementById('gmaps');

//   if (!existingScript) {
//     const script = document.createElement('script');
//     script.src = src;
//     script.id = 'gmaps';
//     document.body.appendChild(script);

//     script.onload = () => {
//       setTimeout(() => {
//         Maps.initMaps();
//       }, 3000)
//     };
//   }
//   if (existingScript){
//         setTimeout(() => {
//         Maps.initMaps();
//       }, 3000)
//   };
// };
Maps.loadJS = (src) => {
  return new Promise((resolve, reject) => {
    const existingScript = document.getElementById("gmaps");

    if (!existingScript) {
      const script = document.createElement("script");
      script.src = src;
      script.id = "gmaps";
      script.async = true;
      script.defer = true;

      script.onload = () => {
        resolve();
      };

      script.onerror = () => {
        console.error("Failed to load Google Maps script.");
        reject(new Error("Failed to load Google Maps script."));
      };

      document.body.appendChild(script);
    } else {
      console.log("Google Maps script already exists.");
      resolve();
    }
  });
};

Maps.addJS = () => {
  if (!document.getElementById("gmaps")) {
    Maps.loadJS(
      "https://maps.googleapis.com/maps/api/js?key=" +
        Settings.get("google_maps_app_id") +
        "&loading=async&language=" +
        Translations.getCurrentLanguage() +
        "&libraries=places,marker&callback=mapLoaded"
    );
  }
};

Maps.rerender = (id) => {
  Maps.maps.event.trigger(Maps.instances[id], "resize");
};

Maps.findPlace = (id, latLng, panTo = false) => {
  let geocoder = new window.google.maps.Geocoder();
  geocoder.geocode(
    {
      latLng: latLng,
    },
    function(results, status) {
      if (status === window.google.maps.GeocoderStatus.OK) {
        if (results[0]) {
          let place = results[0];
          Maps.setLastPlace(id, place);
          if (panTo) {
            Maps.instances[id].panTo(latLng); // only for user location
          }
        }
      }
    }
  );
};

Maps.createMapListener = (id) => {
  // let pressTimer;

  let clickTimer;

  // Maps.instances[id].addListener("mousedown", function(e) {
  //   pressTimer = window.setTimeout(function() {

  //   }, Maps.long_press_ms);
  // });

  // Maps.instances[id].addListener("mouseup", function(e) {
  //   clearTimeout(pressTimer);
  // });

  Maps.instances[id].addListener("click", function(e) {
    // If the event has a placeId, use it.
    if (Maps.isIconMouseEvent(e)) {
      // Calling e.stop() on the event prevents the default info window from showing.
      // If you call stop here when there is no placeId you will prevent some
      // other map click event handlers from receiving the event.
      e.stop();

      // if (event.placeId) {
      //   this.calculateAndDisplayRoute(event.placeId);
      //   this.getPlaceInformation(event.placeId);
      // }
    }

    clickTimer = window.setTimeout(function() {
      Maps.findPlace(id, e.latLng);

      // Maps.instances[id].panTo(e.latLng); // disabled by request
    }, Maps.click_press_ms);
  });

  Maps.instances[id].addListener("dblclick", function(e) {
    clearTimeout(clickTimer);
    let current_zoom = Maps.instances[id].getZoom();
    Maps.instances[id].setZoom(current_zoom + 1);
  });
};

Maps.isIconMouseEvent = (e) => {
  return "placeId" in e;
};

Maps.setLastPlace = (map_id, place) => {
  let latlng = {
    lat: place.geometry.location.lat(),
    lng: place.geometry.location.lng(),
  };

  Maps.setMarker(latlng, map_id, "user_location");

  Storage.set("map_" + map_id + "_marker", latlng);
  Storage.set("map_" + map_id + "_last_place", place);

  Storage.set("user_location", latlng);
  Storage.set("currentCordinates", latlng);
};

Maps.createMap = (map_id, mapRef, options) => {
  let node = ReactDOM.findDOMNode(mapRef.current);
  let center = new Maps.maps.LatLng(
    Settings.map_center_lat,
    Settings.map_center_lng
  );

  if (node) {
    Maps.config[map_id] = {
      mapId: "45d2fa3bb252fe30",
      zoom: 10,
      minZoom: 2,
      // clickableIcons: false, // disable points of interest icons
      center: center,
      mapTypeControl: false,
      navigationControl: true,
      streetViewControl: false,
      fullscreenControl: false,
      zoomControl: true,
      zoomControlOptions: {
        position: Maps.maps.ControlPosition.LEFT_CENTER,
      // bundled: false,
      },
      mapTypeId: Maps.maps.MapTypeId.ROADMAP,
    };
  if (options && options["freeze"]) {
     Maps.config[map_id]["draggable"] = false;
     Maps.config[map_id]["scrollwheel"] = false;
     Maps.config[map_id]["panControl"] = false;
     Maps.config[map_id]["mapTypeControl"] = false;
     Maps.config[map_id]["fullscreenControl"] = false;
     Maps.config[map_id]["navigationControl"] = false;
     Maps.config[map_id]["maxZoom"] = 10;
     Maps.config[map_id]["minZoom"] = 10;
     Maps.config[map_id]["zoom"] = 10;
     Maps.config[map_id]["zoomControl"] = false;
     Maps.config[map_id]["preserveViewport"] = true;

  }
    let drawSaved = null;

    let map = new Maps.maps.Map(node, Maps.config[map_id]);
    Maps.directionsDisplay.setMap(map);
    map.bounds = new Maps.maps.LatLngBounds();

    if (Maps.instances[map_id]) {
      let last_place = Storage.get("map_" + map_id + "_last_place");
      if (last_place) {
        drawSaved = () => {
          let latlng = {
            lat: last_place.geometry
              ? last_place.geometry.location.lat()
              : last_place.lat,
            lng: last_place.geometry
              ? last_place.geometry.location.lng()
              : last_place.lng,
          };
          Maps.setMarker(latlng, map_id, "last_place");
        };
      }
    } else {
      Storage.clear("map_" + map_id + "_marker");
      Storage.clear("map_" + map_id + "_last_place");
      Storage.clear("user_location");
      Storage.clear("currentCordinates");
    }

    Maps.instances[map_id] = map;

    Maps.createMapListener(map_id);

    setTimeout(() => {
      if (drawSaved) {
        drawSaved();
      }
    }, 200);

    return Maps.instances[map_id];
  }
  return null;
};

Maps.createMarker = (map_id, place) => {
  let latlng = new window.google.maps.LatLng(place.lat, place.lng);
  Maps.instances[map_id].bounds.extend({
    lat: latlng.lat(),
    lng: latlng.lng(),
  });

  let mapDistance,
    contentString,
    getDirectionLink = "";

  if (Storage.get("currentCordinates")) {
    mapDistance = Maps.getDistance(latlng);

    let latitude, longitude;
    if (Storage.get("currentCordinates").latitude) {
      latitude = Storage.get("currentCordinates").latitude;
      longitude = Storage.get("currentCordinates").longitude;
    } else {
      latitude = Storage.get("currentCordinates").lat;
      longitude = Storage.get("currentCordinates").lng;
    }

    getDirectionLink =
      '<a href="https://www.google.com.sa/maps?saddr=' +
      latitude +
      "," +
      longitude +
      "&amp;daddr=" +
      place.lat +
      "," +
      place.lng +
      '" target="_blank" class="get-direction">Get Direction</a>';

    if (mapDistance === "not allowed") {
      mapDistance = "";
      getDirectionLink = "";
    }
  }

  contentString =
    getDirectionLink +
    '<div class="infoBuble">' +
    '<div class="infoTop">' +
    '<div class="storeIcon"></div>' +
    '<div class="storeInfo">' +
    '<div class="storeName">' +
    place.name +
    "</div>" +
    '<div class="storePhone">' +
    place.phone +
    "</div>" +
    "</div>" +
    "</div>" +
    '<div class="infoButtom">' +
    mapDistance +
    place.address_1 +
    " " +
    "</div>" +
    "</div>";

  var image = {
    url: ETA_MAP_PIN,
    scaledSize: new Maps.maps.Size(46, 46),
    origin: new Maps.maps.Point(0, 0),
    anchor: new Maps.maps.Point(24, 24),
  };

  let marker = new Maps.maps.Marker({
    position: latlng,
    icon: image,
    map: Maps.instances[map_id],
    zIndex: Math.round(latlng.lat * -100000) << 5,
  });
  Maps.maps.event.addListener(marker, "click", function() {
    if (Maps.instances[map_id].infowindow) {
      Maps.instances[map_id].infowindow.close();
    }

    Maps.instances[map_id].infowindow = new Maps.maps.InfoWindow();
    Maps.instances[map_id].setCenter(latlng);
    Maps.instances[map_id].infowindow.setContent(contentString);
    Maps.instances[map_id].infowindow.open(Maps.instances[map_id], marker);
  });

  return marker;
};

Maps.hidePopup = (map) => {
  Maps.instances[map].infowindow.close();
};

Maps.createPin = (map_id, latlng, name, html, pin = null) => {
  if (!pin) {
    pin = min60Pin;
  }
  if (userHasDevicePlan()){
    pin = generalMapPin;
  }
  // var icon = {
  //   url: pin,
  //   scaledSize: new Maps.maps.Size(46, 46),
  //   origin: new Maps.maps.Point(0, 0),
  //   anchor: new Maps.maps.Point(24, 24),
  // };
  // let marker = new Maps.maps.Marker({
  //   position: latlng,
  //   map: Maps.instances[map_id],
  //   icon: icon,
  //   zIndex: Math.round(latlng.lat * -100000) << 5,
  // });
  const content = document.createElement("div");
  content.style.backgroundImage = `url(${pin})`;
  content.style.width = `68px`;
  content.style.height = `68px`;
  content.style.backgroundSize = "contain";
  content.style.backgroundRepeat = "no-repeat";

  let marker = new Maps.maps.marker.AdvancedMarkerElement({
    position: latlng,
    map:  Maps.instances[map_id],
    content: content,
    zIndex: Math.round(latlng.lat * -100000) << 5,
    title: map_id,
  });
  return marker;
};

Maps.clearMarkers = (map_id) => {
  let placesKeys = Object.keys(Maps);
  let places = placesKeys.filter((elem) => elem.substring(0, 6) === "place_");
  for (let i = 0; i < places.length; i++) {
    Maps[places[i]].setMap(null);
  }
  if (Maps["last_place"]) {
    Maps["last_place"].setMap(null);
  }
};

Maps.setMarker = (latLng, map_id, marker_id, pin = null) => {
  if (latLng) {
    if (Maps[marker_id]) {
      Maps.clearMarkers(map_id);
      Maps[marker_id].setMap(null);
    }

    Maps[marker_id] = Maps.createPin(
      map_id,
      latLng,
      "name",
      "<b>Location</b><br>" + latLng.lat + ", " + latLng.lng,
      pin
    );
  }

  if (Maps.config[map_id]) {
    Maps.config[map_id]["center"] = new Maps.maps.LatLng(
      latLng.lat + Maps.lat_shift,
      latLng.lng
    );
    Maps.instances[map_id].setCenter(Maps.config[map_id]["center"]);
    Maps.instances[map_id].setZoom(10);
  }

  Storage.set("map_" + map_id + "_marker", latLng);
  Storage.clear("map_" + map_id + "_formatted_address");
  Storage.set("user_location", latLng);
  Storage.set("currentCordinates", latLng);
};

Maps.detect_location = () => {
  if (Maps.user_lat > 0) {
    var pos = {
      lat: Maps.user_lat,
      lng: Maps.user_lng,
    };
    Maps.using_current_location = true;
    Maps.setMarker(pos, Object.keys(Maps.instances)[0], "user_location");
  }
};

Maps.handleCurrentPosition = (position) => {
  if (Maps.using_current_location) {
    Maps.fetchingCurrentPosition = false;
    Maps.user_lng = position.coords.longitude;
    Maps.user_lat = position.coords.latitude;
    var pos = {
      lat: position.coords.latitude,
      lng: position.coords.longitude,
    };

    Maps.setMarker(pos, Object.keys(Maps.instances)[0], "user_location");
  }
};
Maps.locateUser = (map_id) => {
  if (navigator.geolocation && !Storage.get("fetchingCurrentPosition")) {
    Storage.set("fetchingCurrentPosition", true);
    // let d = new Date();
    // console.log("Fetching location started at :");
    // console.log(d.toLocaleTimeString());

    navigator.geolocation.watchPosition(function(position) {
      Maps.handleCurrentPosition(position);

      if (Maps.watcherOff) {
        return;
      }
      Maps.watcherOff = true;

      if (Storage.get("fetchingCurrentPosition")) {
        // let d = new Date();
        // console.log("Location found at :");
        // console.log(d.toLocaleTimeString());

        let pos = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };

        Storage.clear("fetchingCurrentPosition");

        Storage.set("user_location", pos);

        Maps.setMarker(pos, map_id, "user_location");
      }
    });

    navigator.geolocation.getCurrentPosition(
      function(position) {
        // console.log("success: fetched location");
        Storage.set("currentCordinates", position.coords);
        Storage.clear("fetchingCurrentPosition");
        let latLng = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };

        Maps.findPlace(map_id, latLng, true);
      },
      function() {
        // console.log("error: fetching location");
        Storage.set("fetchingCurrentPosition", false);
        Storage.set("currentCordinates", "not allowed");
        Storage.clear("fetchingCurrentPosition");
      }
    );
  } else {
    if (Storage.get("user_location")) {
      Maps.setMarker(
        Storage.get("user_location"),
        Object.keys(Maps.instances)[0],
        "user_location"
      );
    }
  }
};

Maps.rad = (x) => {
  return x * Math.PI / 180;
};
Maps.calculateDistance = (p2) => {
  if (Storage.get("currentCordinates") === "not allowed") {
    return "not allowed";
  }

  var latitude, longitude;

  if (Storage.get("currentCordinates").latitude) {
    latitude = Storage.get("currentCordinates").latitude;
    longitude = Storage.get("currentCordinates").longitude;
  } else {
    latitude = Storage.get("currentCordinates").lat;
    longitude = Storage.get("currentCordinates").lng;
  }

  var latLngA = new window.google.maps.LatLng(latitude, longitude);
  var latLngB = new window.google.maps.LatLng(p2.lat(), p2.lng());
  var d = window.google.maps.geometry.spherical.computeDistanceBetween(
    latLngA,
    latLngB
  );

  if (d > 1000) {
    return parseFloat(d / 1000).toFixed(2) + " Km ";
  }
  return parseInt(d, 10) + " m ";
};

Maps.getDistance = (p2) => {
  return Maps.calculateDistance(p2);
};

Maps.setFilters = (filters) => {
  Maps.allFilters = {};
  if (filters) {
    let filtersLength = filters.length;
    for (let i = 0; i < filtersLength; i++) {
      Maps.allFilters[filters[i].code] = filters[i].code;
    }
  }
};

Maps.filter = (filters, places) => {
  let filterValues = Object.keys(filters);
  let placesLength = Maps.markers.length;

  for (let i = 0; i < placesLength; i++) {
    let storeType = places[i].type.split("");
    const found = storeType.some((r) => filterValues.indexOf(r) >= 0);
    if (found) {
      Maps.markers[i].setVisible(true);
    } else {
      Maps.markers[i].setVisible(false);
    }
  }
};

Maps.drawPlaces = (map_id, places) => {
  if (places.length === 0) {
    return;
  }

  // Clear out the old markers.
  Maps.markers.forEach(function(marker) {
    marker.setMap(null);
  });
  Maps.markers = [];

  places.forEach((place) => {
    let mrk = Maps.createMarker(map_id, place);
    Maps.markers.push(mrk);
  });

  Maps.instances[map_id].fitBounds(Maps.instances[map_id].bounds);
  Maps.instances[map_id].setZoom(5.8);
};

Maps.displaySuggestions = (namespace, predictions, status) => {
  if (status !== Maps.maps.places.PlacesServiceStatus.OK) {
    Storage.clear(namespace + "_autocomplete_predictions");
    return;
  }
  Storage.set(namespace + "_autocomplete_predictions", predictions);
};

Maps.clearSuggestions = (namespace) => {
  Storage.clear(namespace + "_autocomplete_predictions");
};

Maps.fetchPlaceDetails = (map_id, place_id) => {
  let map = Maps.instances[map_id];
  let request = {
    placeId: place_id,
    fields: ["formatted_address", "geometry", "name", "address_components"],
  };
  let service = new Maps.maps.places.PlacesService(map);
  service.getDetails(request, (place, status) => {
    if (status === Maps.maps.places.PlacesServiceStatus.OK) {
      // set address
      Maps.setLastPlace(map_id, place);
    }
  });
  Maps.generateMapsSessionUUID();
};

Maps.fetchPlacePredictions = (namespace, search_term = null) => {
  if (search_term) {
    let service = new Maps.maps.places.AutocompleteService();
    let request = {
      input: search_term,
      //fields: ['geometry', 'formatted_address'],
      sessiontoken: Maps.getMapsSessionUUID(),
      componentRestrictions: { country: "ae" },
    };
    service.getPlacePredictions(request, (predictions, status) => {
      Maps.displaySuggestions(namespace, predictions, status);
    });
  } else {
    Storage.clear(namespace + "_autocomplete_predictions");
  }
};

Maps.getMapsSessionUUID = () => {
  if (!Maps.session_token) {
    Maps.generateMapsSessionUUID();
  }
  return Maps.session_token;
};

Maps.generateMapsSessionUUID = () => {
  Maps.session_token = Storage.get("session") + Date.now();
  return Maps.session_token;
};

Maps.addSearch = (searchRef, map_id) => {
  // Create the search box and link it to the UI element.
  var input = searchRef.current;

  // var container = document.getElementById('map_search');
  var searchBox = new Maps.maps.places.SearchBox(input);
  // dis.map.controls[dis.maps.ControlPosition.BOTTOM_LEFT].push(container);

  Maps.instances[map_id].addListener("bounds_changed", function() {
    searchBox.setBounds(Maps.instances[map_id].getBounds());
  });

  searchBox.addListener("places_changed", function() {
    var places = searchBox.getPlaces();

    if (places.length === 0) {
      return;
    }

    // For each place, get the icon, name and location.

    var bounds = new Maps.maps.LatLngBounds();
    places.forEach(function(place) {
      if (!place.geometry) {
        Helpers.log("Returned search place contains no geometry");
        return;
      }

      let latlng = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };

      Maps.setMarker(latlng, map_id, "place_" + place.name);

      Storage.set("map_" + map_id + "_last_place", place);

      if (place.geometry.viewport) {
        // Only geocodes have viewport.
        bounds.union(place.geometry.viewport);
      } else {
        bounds.extend(place.geometry.location);
      }
    });

    Maps.instances[map_id].fitBounds(bounds);

    Storage.set("fetchingCurrentPosition", false);
  });
};

Maps.initMaps = () => {
  Maps.maps = window.google.maps;
  Maps.directionsService = new Maps.maps.DirectionsService();
  Maps.directionsDisplay = new Maps.maps.DirectionsRenderer();

  Storage.set("maps_loaded", true);
};

Maps.mapLoaded = () => {
  Maps.mapIsLoaded = true;
  Maps.initMaps()
};

window.mapLoaded = () => {
  Maps.mapLoaded();
};

Maps.addJS();

export default Maps;
